import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ButtonPosition {
  x: number;
  y: number;
}

interface GameState {
  score: number;
  timeLeft: number;
  isGameActive: boolean;
  gameStarted: boolean;
  buttonPosition: ButtonPosition;
  screenWidth: number;
  screenHeight: number;
  gameOver: boolean;
}

const initialState: GameState = {
  score: 0,
  timeLeft: 10,
  isGameActive: false,
  gameStarted: false,
  buttonPosition: { x: 50, y: 50 },
  screenWidth: 300,
  screenHeight: 500,
  gameOver: false,
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    startGame: (state) => {
      state.isGameActive = true;
      state.gameStarted = true;
      state.gameOver = false;
      state.score = 0;
      state.timeLeft = 10;
      // Generate random button position
      state.buttonPosition = {
        x: Math.random() * (state.screenWidth - 60),
        y: Math.random() * (state.screenHeight - 60),
      };
    },
    pauseGame: (state) => {
      state.isGameActive = false;
    },
    resumeGame: (state) => {
      state.isGameActive = true;
    },
    resetGame: (state) => {
      state.score = 0;
      state.timeLeft = 10;
      state.isGameActive = false;
      state.gameStarted = false;
      state.gameOver = false;
      state.buttonPosition = { x: 50, y: 50 };
    },
    decrementTime: (state) => {
      if (state.timeLeft > 0) {
        state.timeLeft -= 1;
      }
      if (state.timeLeft === 0) {
        state.isGameActive = false;
        state.gameOver = true;
      }
    },
    incrementScore: (state) => {
      state.score += 1;
      // Generate new random position for button
      state.buttonPosition = {
        x: Math.random() * (state.screenWidth - 60),
        y: Math.random() * (state.screenHeight - 60),
      };
    },
    setScreenDimensions: (state, action: PayloadAction<{width: number; height: number}>) => {
      state.screenWidth = action.payload.width;
      state.screenHeight = action.payload.height;
    },
  },
});

export const {
  startGame,
  pauseGame,
  resumeGame,
  resetGame,
  decrementTime,
  incrementScore,
  setScreenDimensions,
} = gameSlice.actions;

export default gameSlice.reducer;
